module.exports = __webpack_public_path__ + "static/media/01.6963caf4.jpg";